import { ControlledSelect } from 'components/Select/ControlledSelect';

import { useVoucherContext } from '../../context';
import { useContext, useEffect } from 'react';
import { JoinUsContext } from 'customHooks/useJoinUs/useJoinUs';
import { useFormContext } from 'react-hook-form';

import { getCurrencyOptionsVoucher } from 'blocks/sign-up/options';

import type { CurrencySelectProps } from './types';
import type { MultiVoucherFormSchema } from '../schema';
import type { VoucherFieldName } from '../types';
import type { SupportedCurrencyCode } from 'types/types';

const CurrencySelect: React.FC<CurrencySelectProps> = ({ name }) => {
  const {
    state: { currencies },
  } = useVoucherContext();

  const {
    joinUsState: { currency: defaultCurrency },
  } = useContext(JoinUsContext);

  const { setValue } = useFormContext<MultiVoucherFormSchema>();

  useEffect(() => {
    if (!defaultCurrency) {
      return;
    }

    setValue(
      name as VoucherFieldName,
      defaultCurrency as SupportedCurrencyCode
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCurrency]);

  return (
    <ControlledSelect
      name={name}
      label=""
      options={getCurrencyOptionsVoucher(currencies)}
      layout="CURRENCY"
    />
  );
};

export default CurrencySelect;
